export const btnRep = `<button class="btn">button</button>
<button class="btn dark">button</button>
<button class="btn outline">button</button>
<button class="btn lg">button</button>
<button class="btn wide">button</button>`

export const a = `<a href="#" class="btn md dark">link</a>
<a href="#" class="btn md light">link</a>
<a href="#" class="btn md success">link</a>
<a href="#" class="btn md danger">link</a>
<a href="#" class="btn md info">link</a>
<a href="#" class="btn md primary">link</a>
<a href="#" class="btn md warning">link</a>
<a href="#" class="btn md secondary">link</a>`

export const input = `<input type="button" value="input" class="btn md dark" />
<input type="button" value="input" class="btn md light" />
<input type="button" value="input" class="btn md success" />
<input type="button" value="input" class="btn md danger" />
<input type="button" value="input" class="btn md info" />
<input type="button" value="input" class="btn md primary" />
<input type="button" value="input" class="btn md warning" />
<input type="button" value="input" class="btn md secondary" />`

export const button = `<button class="btn md dark">button</button>
<button class="btn md light">button</button>
<button class="btn md success">button</button>
<button class="btn md danger">button</button>
<button class="btn md info">button</button>
<button class="btn md primary">button</button>
<button class="btn md warning">button</button>
<button class="btn md secondary">button</button>`

export const size = `<button class="btn sm">button</button>
<button class="btn md">button</button>
<button class="btn lg">button</button>
<button class="btn xl">button</button>

<button class="btn sm wide">button</button>
<button class="btn md wide">button</button>
<button class="btn lg wide">button</button>
<button class="btn xl wide">button</button>`